var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kgk-teamless"},[_c('CreateTeam',{on:{"created":function($event){return _vm.$emit('triggerReload')}}}),_c('div',{staticClass:"spacer"}),_c('UserInvitesList',{on:{"accepted":function($event){return _vm.$emit('triggerReload')},"declined":function($event){return _vm.$emit('triggerReload')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }